import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Box, Card, CardHeader, styled } from '@mui/material';
// utils
import { fNumber } from '../../../utils/formatNumber';
// components
import { useChart } from '../../../components/chart';
import { t } from 'i18next';


const StyledTitle = styled('div')(({ theme }) => ({
    fontSize: '30px', // Cỡ chữ mặc định
    [theme.breakpoints.down('md')]: {
        fontSize: '27px', // Cỡ chữ cho màn hình trung bình
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '18px', // Cỡ chữ cho màn hình nhỏ
    },
    [theme.breakpoints.down('xs')]: {
        fontSize: '16px', // Cỡ chữ cho màn hình rất nhỏ
    },
}));
const StyledSubheader = styled('div')(({ theme }) => ({
    fontSize: '23px', // Cỡ chữ mặc định
    [theme.breakpoints.down('md')]: {
        fontSize: '25px', // Cỡ chữ cho màn hình trung bình
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '16px', // Cỡ chữ cho màn hình nhỏ
    },
    [theme.breakpoints.down('xs')]: {
        fontSize: '14px', // Cỡ chữ cho màn hình rất nhỏ
    },
}));
// ----------------------------------------------------------------------

AppConversionRates.propTypes = {
    title: PropTypes.string,
    subheader: PropTypes.string,
    chartData: PropTypes.array.isRequired,
};

export default function AppConversionRates({
    title,
    subheader,
    chartColors,
    totalLabel = t('total'),
    chartData,
    label = 'label',
    value = 'value',
    ...other
}) {
    // Giới hạn hiển thị top 30 items, gộp còn lại vào "Khác" để tối ưu hiệu năng
    const MAX_ITEMS = 30;
    const sortedData = [...chartData].sort((a, b) => (b[value] || 0) - (a[value] || 0));
    const topItems = sortedData.slice(0, MAX_ITEMS);
    const otherItems = sortedData.slice(MAX_ITEMS);
    const otherValue = otherItems.reduce((sum, item) => sum + (item[value] || 0), 0);

    const displayData = otherValue > 0 ? [...topItems, { [label]: 'Khác', [value]: otherValue }] : topItems;

    const chartLabels = displayData.map((i) => i[label]);

    const chartSeries = displayData.map((i) => i[value]);

    const total = displayData.reduce(
        (accumulator, currentValue) => accumulator + (currentValue[value] ? currentValue[value] : 0),
        0
    );

    const chartOptions = useChart({
        // tooltip: {
        //     marker: { show: true },
        //     y: {
        //         formatter: (seriesName) => fNumber(seriesName),
        //         title: {
        //             formatter: () => '',
        //         },
        //     },
        // },
        plotOptions: {
            bar: { 
                horizontal: true, 
                barHeight: '50%', // Giữ nguyên kích thước bar
                borderRadius: 3,
                distributed: true,
            },
        },
        grid: {
            row: {
                colors: ['transparent', 'transparent'], // Loại bỏ grid lines để dễ đọc hơn
            },
        },
        xaxis: {
            categories: chartLabels,
            labels: {
                style: {
                    fontSize: '11px',
                },
                offsetY: 0,
            },
        },
        dataLabels: {
            enabled: true,
            offsetX: 0,
            style: {
                fontSize: '11px',
                colors: ['#fff'],
            },
            formatter: function (val, opt) {
                return fNumber(val);
            },
            dropShadow: {
                enabled: true,
            },
        },
        legend: {
            show: true,
            showForSingleSeries: true,
            fontSize: '14px',
            customLegendItems: [t('total') + ': ' + fNumber(total)],
            markers: {
                fillColors: ['#00E396', '#775DD0'],
            },
        },
        tooltip: {
            // theme: 'dark',
            x: {
                show: true,
            },
            y: {
                formatter: (seriesName) => fNumber(seriesName),
                title: {
                    formatter: function () {
                        return '';
                    },
                },
            },
        },
    });

    return (
        <Card {...other}>
            <CardHeader title={<StyledTitle>{title}</StyledTitle>} subheader={<StyledSubheader>{subheader}</StyledSubheader>} />

            <Box sx={{ mx: 3, mt: 2 }} dir="ltr">
                <ReactApexChart 
                    type="bar" 
                    series={[{ data: chartSeries }]} 
                    options={chartOptions} 
                    height={displayData.length * 40} // Tính chiều cao động: mỗi bar 120px
                />
            </Box>
        </Card>
    );
}
